export const testimonial = [
  {
    testimonial:
      "This platform exceeded my expectations. The user interface is intuitive and the support team is incredibly responsive.",
    name: "Alice Johnson",
    position: "Product Manager at TechNova",
    rating: 5,
  },
  {
    testimonial:
      "A decent experience overall, but there’s room for improvement in terms of performance and speed.",
    name: "Mark Thompson",
    position: "Software Engineer at CloudCore",
    rating: 3,
  },
  {
    testimonial:
      "Absolutely love using this service! It has streamlined our workflow and saved us hours each week.",
    name: "Sandra Lee",
    position: "Operations Lead at FinEdge",
    rating: 5,
  },
  {
    testimonial:
      "The features are great, but it took some time to get used to the layout. Once familiar, it works well.",
    name: "James Carter",
    position: "Marketing Specialist at BrightByte",
    rating: 4,
  },
  {
    testimonial:
      "I wasn’t fully satisfied with the results. Customer service was helpful, but the tool lacked some critical features for us.",
    name: "Priya Mehra",
    position: "Data Analyst at InsightHub",
    rating: 2,
  },
];
